import { jsx as a, Fragment as o } from "react/jsx-runtime";
import { Typography as l } from "@vp/swan";
import { calculateHighlightChunks as f } from "./help-center-articles-search47.js";
import { ALGOLIA_HIGHLIGHT_TAG as H, ALGOLIA_HIGHLIGHT_TAG_REGEXP as G, SEARCH_BAR_HIGHLIGHT_TAG as d, EM_TAG_PLACEHOLDER as A, END_EM_TAG_PLACEHOLDER as _ } from "./help-center-articles-search19.js";
const p = ({ resultText: r }) => {
  if (!r) return null;
  if (r.indexOf(H) !== -1 && (r = r.replace(G, d)), r.indexOf("<em>") === -1) return /* @__PURE__ */ a(o, { children: r });
  const t = f(r);
  let n = !1;
  return /* @__PURE__ */ a(o, { children: t.map((i, e) => i === A ? (n = !0, null) : i === _ ? (n = !1, null) : n ? /* @__PURE__ */ a(l, { as: "mark", fontWeight: "bold", color: "standard", backgroundColor: "transparent", children: i }, i + e) : i) });
};
export {
  p as default
};
//# sourceMappingURL=help-center-articles-search29.js.map
